$(window).on('scroll',function(e){
  var body_scrollsec = $(window).scrollTop();
  var m_header_height = $('.header-group').height(); 
  $('.main-banner-cls').each(function(e){
    var article_next_div = $(this).next('.shopify-section').offset().top-$(window).height();
    var half_articl_next = Math.round(article_next_div/2);
    var this_div = $(this);
    if(body_scrollsec<article_next_div){
      this_div.find('.section-main-banner').css({transform: 'scale('+(100 - body_scrollsec/50)/100+')'});
      var border_raidus = body_scrollsec/70;
      this_div.find('.main-banner').css('border-radius',border_raidus);       
      if(body_scrollsec>=half_articl_next){
        this_div.addClass('change_overlay');
      }else{
        this_div.removeClass('change_overlay');
      }
    }
  });
});